import { AI } from '@lumapps/ai/keys';
import { mdiSparkles, mdiExclamationThick } from '@lumapps/lumx/icons';
import { GLOBAL } from '@lumapps/translations';

import { ASK_AI } from './keys';
import type { AskAiServiceErrors } from './types';

/** Token for the AskAI feature flag */
export const ASK_AI_FF = 'ask-ai';

/** Token for the AskAI alpha feature flag */
export const ASK_AI_ALPHA_FF = 'ask-ai-alpha';

/** Token for the AskAI beta feature flag */
export const ASK_AI_BETA_FF = 'ask-ai-beta';

export const ASK_AI_SCOPE = 'ask-ai';

/** All info required for AskAi empty states */
export const EMPTY_STATES = {
    noResults: { icon: mdiSparkles, description: GLOBAL.TRY_ANOTHER_QUERY, subtitle: ASK_AI.NO_RESOURCES_TITLE },
};

/** All info required for AskAi error states */
export const ERROR_STATES_BY_CODE: Record<
    AskAiServiceErrors['code'] | 'default',
    {
        icon: string;
        subtitle: string;
        description: string;
    }
> = {
    default: {
        icon: mdiExclamationThick,
        subtitle: ASK_AI.ERROR_TITLE,
        description: ASK_AI.ERROR_DESC,
    },
    TOO_MANY_REQUESTS: {
        icon: mdiExclamationThick,
        subtitle: ASK_AI.ERROR_TITLE,
        description: ASK_AI.REACHED_MAXIMUM_USAGE,
    },
    LLM_RESOURCE_EXHAUSTED: {
        icon: mdiExclamationThick,
        subtitle: AI.AI_SERVICES_EXPERIENCING_HIGH_DEMAND,
        description: ASK_AI.ERROR_DESC,
    },
};

/**
 * The max height the ask-ai banner should have before showing a "show more" button,
 * excluding the height of the "show more" button.
 * The preview height is only used in the micro-apps builder
 * The webview height is only used in the search webview
 */
export const ASK_AI_MAX_HEIGHT = 260;
export const ASK_AI_MAX_HEIGHT_PREVIEW = 520;
export const ASK_AI_MAX_HEIGHT_WEBVIEW = 130;

/** Root path of the ask ai backoffice section  */
export const ASK_AI_ADMIN_ROOT_PATH = 'ai-search';

/** Status of the streaming request of Ask AI Chat */
export enum ASK_AI_CHAT_STREAMING_STATUS {
    MATCHING_RULES = 'matching_rules',
    SEARCHING_SOURCES = 'searching_sources',
    STREAMING_ANSWER = 'streaming_answer',
    DONE = 'done',
}
